const UQ = "?crop=entropy&cs=srgb&fm=jpg&w=900&q=80";

export const CATS = [
  ["T-Shirts", "/shop?type=t-shirt", "https://images.unsplash.com/photo-1737094540182-d602f8a7dd1d" + UQ, "bg-sun"],
  ["Hats", "/collections/vacation-hats", "https://images.unsplash.com/photo-1691256676359-20e5c6d4bc92" + UQ, "bg-turq"],
  ["Hoodies", "/shop?type=hoodie", "https://images.unsplash.com/photo-1620799140188-3b2a02fd9a77" + UQ, "bg-sunset"],
  ["Family", "/collections/family-vacation-shirts", "https://images.unsplash.com/photo-1597524678053-5e6fef52d8a3" + UQ, "bg-tpink"],
  ["Couples", "/collections/couples-vacation-apparel", "https://images.unsplash.com/photo-1623137285532-ec3df3e9abc7" + UQ, "bg-sun"],
];

export const variantPrice = (p, color, size) =>
  p.variants?.find((v) => v.color === color && v.size === size)?.price ?? p.price;

export const HERO = "https://static.prod-images.emergentagent.com/jobs/5533ca89-2c5a-4f84-ac40-58e7b721e70e/images/519fb5d9e4b9653799e7e236285e2512d4872ae284d5f28933d207a680a055d0.jpeg";
